/*import React from 'react'
import ReactDOM from 'react-dom'
import $ from 'jquery'*/
import _ from 'lodash'
import moment from 'moment'


export default class SVGraphSigma  {


    aggegationMeasures={

            
        sum:{
            name:'Total',
            type:1
        },
        median:{
            name:'Median',
            type:2
        },
         min:{
            name:'Min',
            type:3
        },
        max:{
            name:'Max',
            type:4,
        },
        count:{
            name:'Count',
            type:5
        },
        avg:{
            name:'Average',
            type:6
        }


    };
    ruleNames={

        SHORT:
        {
            name:'SHORT',
            id:1
        },
        BINAME:{
            name:'BINAME',
            id:2
        },


    };

     fromBIName (ruleName, item) {
                //apply Rule short
                var models;
                if (item.indexOf('.') < 0) {
                    
                    return item;
                } else if (item && (item == null)) {
                    
                    return 'sv1cat';
                }
                if (item.length < 1) {
                    
                    return 'svCatDefaultNameServerError';
                }
                if (ruleName == 'SHORT') {
                    models = item.split('.');
                    return models.reverse()[0];
                }

            };

    aggegationName (type){
        let me = this
        var name = '';
       var k = _.findKey(me.aggegationMeasures, {type:type});
       
        console.log('svk  aggegationMeasures:' + k)
       if(k &&  (!_.isUndefined(k)) && (!_.isUndefined(me.aggegationMeasures[k])) ){
        name = me.aggegationMeasures[k].name;
       }
       return name;


    }
    narrowMeasure = function(data, unitName, sigma, periodType, measure, channelView, channel) {
        //Step1 get buckets
        let me = this
        //var 
        var vView = {
            fromDate: "04/27/2016",
            toDate: "07/06/2017",
        };
        var sigmaInfo = channel.data.value;
        var sigmaView;

        //  var buckets = incomesvMonthSlots(1, vView.fromDate, vView.toDate);
        var buckets = ["Apr 2016", "May 2016", "Jun 2016", "Jul 2016"];
        

        //Step we have weeky excursion so we do not need week range

        for (var i = 0; i < unitName.length; i++) {
            var sigmaMeasure = 0, sigmaView;
            var svcatname =  me.fromBIName( me.ruleNames.SHORT.name, unitName[i]);
            var view = data[svcatname];
            if (view && _.isArray(view) && (view.length > 0)) {
                 sigmaView = _.clone(view[0]);


            } else {

            }

            _.each(view, function(v, idx) {
                //got aft

                sigmaMeasure += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure] = sigmaMeasure;
            sigmaInfo[svcatname] = sigmaView;
            // sigmaInfo[svcatname] = sigmaMeasure;

        }


        //sv now lopp to get aggreagte

        return sigmaInfo;



    };

     narrowWeek(data, unitName, sigma, periodType, measure, channelView, channel) {
        //Step1 get buckets
        //var 
        var me = this
        var vView = {
            fromDate: "04/27/2016",
            toDate: "07/06/2017",
        };
        var sigmaInfo = channel.data.value;
        var sigmaView;

        //  var buckets = incomesvMonthSlots(1, vView.fromDate, vView.toDate);
        var buckets = ["Apr 2016", "May 2016", "Jun 2016", "Jul 2016"];
        

        //Step we have weeky excursion so we do not need week range

        for (var i = 0; i < unitName.length; i++) {
            var sigmaMeasure = 0;
            var svcatname =  me.fromBIName( me.ruleNames.SHORT.name, unitName[i]);
            var view = data[svcatname];
            if (view && _.isArray(view) && (view.length > 0)) {
                sigmaView = _.clone(view[0]);


            } else {

            }

            _.each(view, function(v, idx) {
                //got aft

                sigmaMeasure += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure] = sigmaMeasure;
           

            //sv dow for Monday
            var day = 'Mon';
             var svall = 0;

             _.each(view, function(v, idx) {
                //got aft

                svall += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure+'|' +day] = svall;
           

            //svMon..

                 var days = [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat',
                    'Sun'
                ];
                for(var m=0; m < days.length; m++){

                     me.pipeDay( view, days[m], sigmaView);


                }


                //svnow get array
                var arData = [];
                 arData.push(sigmaView['Totallist_unit_price|Sun']);
                arData.push(sigmaView['Totallist_unit_price|Mon']);
                 arData.push(sigmaView['Totallist_unit_price|Tue']);
                  arData.push(sigmaView['Totallist_unit_price|Wed']);
                   arData.push(sigmaView['Totallist_unit_price|Thu']);
                    arData.push(sigmaView['Totallist_unit_price|Fri']); 
                    arData.push(sigmaView['Totallist_unit_price|Sat']);
                    
                     
             sigmaView.svWeeks= arData; 


             sigmaInfo[svcatname] = sigmaView;
            // sigmaInfo[svcatname] = sigmaMeasure;

        }


        //sv now lopp to get aggreagte

        return sigmaInfo;



    };

     narrowAgeTotalCategory = function(data, unitName, sigma, periodType, measure, channelView, channel) {
        //Step1 get buckets
        //var 
        let me =this
        var vView = {
            fromDate: "04/27/2016",
            toDate: "07/06/2017",
        };
        var sigmaInfo = channel.data.value;
        var sigmaView;

        //  var buckets = incomesvMonthSlots(1, vView.fromDate, vView.toDate);
        var buckets = ["Apr 2016", "May 2016", "Jun 2016", "Jul 2016"];
        

        //Step we have weeky excursion so we do not need week range

        for (var i = 0; i < unitName.length; i++) {
            var sigmaMeasure = 0;
            var svcatname =  me.fromBIName( me.ruleNames.SHORT.name, unitName[i]);
            var view = data[svcatname];
            if (view && _.isArray(view) && (view.length > 0)) {
                sigmaView = _.clone(view[0]);


            } else {

            }

            _.each(view, function(v, idx) {
                //got aft

                sigmaMeasure += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure] = sigmaMeasure;
           

            //sv dow for Monday
            var day = 'Mon';
             var svall = 0;

             _.each(view, function(v, idx) {
                //got aft

                svall += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure+'|' +day] = svall;
           

            //svMon..

                /* var days = [
                    '0-5',
                    '6-10',
                    '11-20',
                    '21-27',
                    '28-39',
                    '40+'
                   
                ]; */
                var days = me.ageBands()
                for(var m=0; m < days.length; m++){

                     me.pipeAgeDual( view, days[m], sigmaView,'female', 'male');


                }


                //svnow get array
             /*   var arData = [];
                 arData.push(sigmaView['Totallist_unit_price|Sun']);
                arData.push(sigmaView['Totallist_unit_price|Mon']);
                 arData.push(sigmaView['Totallist_unit_price|Tue']);
                  arData.push(sigmaView['Totallist_unit_price|Wed']);
                   arData.push(sigmaView['Totallist_unit_price|Thu']);
                    arData.push(sigmaView['Totallist_unit_price|Fri']); 
                    arData.push(sigmaView['Totallist_unit_price|Sat']);
            */
            //svnow get array
                var arData = [], arDataRight=[];
                for(var p=0; p < days.length; p++){

                 arData.push(sigmaView['Totalmale|' + days[p]]);
                 arDataRight.push(sigmaView['Totalfemale|' + days[p]]);
                }
                
                    
                     
             sigmaView.svWeeks= arData; 
             sigmaView.svWeeksRight= arDataRight;        
                    
                     
             sigmaView.svWeeks= arData; 


             sigmaInfo[svcatname] = sigmaView;
            // sigmaInfo[svcatname] = sigmaMeasure;

        }


        //sv now lopp to get aggreagte

        return sigmaInfo;



    };


     narrowWeekTotalCategoryDual(data, unitName, sigma, periodType, measure, channelView, channel, days) {
        //Step1 get buckets
        let me = this
        //var 
        var vView = {
            fromDate: "04/27/2016",
            toDate: "07/06/2017",
        };
        var sigmaInfo = channel.data.value;
        var sigmaView;

        //  var buckets = incomesvMonthSlots(1, vView.fromDate, vView.toDate);
        var buckets = ["Apr 2016", "May 2016", "Jun 2016", "Jul 2016"];
        

        //Step we have weeky excursion so we do not need week range

        for (var i = 0; i < unitName.length; i++) {
            var sigmaMeasure = 0;
            var svcatname =  me.fromBIName( me.ruleNames.SHORT.name, unitName[i]);
            var view = data[svcatname];
            if (view && _.isArray(view) && (view.length > 0)) {
                sigmaView = _.clone(view[0]);


            } else {

            }

            _.each(view, function(v, idx) {
                //got aft

                sigmaMeasure += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure] = sigmaMeasure;
           

            //sv dow for Monday
            var day = 'Mon';
             var svall = 0;

             _.each(view, function(v, idx) {
                //got aft

                svall += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure+'|' +day] = svall;
           

            //svMon..

                /* var days = [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat',
                    'Sun'
                ]; */
                for(var m=0; m < days.length; m++){

                     me.pipeDayDual( view, days[m], sigmaView,'quantity');


                }


                //svnow get array
             /*   var arData = [];
                 arData.push(sigmaView['Totallist_unit_price|Sun']);
                arData.push(sigmaView['Totallist_unit_price|Mon']);
                 arData.push(sigmaView['Totallist_unit_price|Tue']);
                  arData.push(sigmaView['Totallist_unit_price|Wed']);
                   arData.push(sigmaView['Totallist_unit_price|Thu']);
                    arData.push(sigmaView['Totallist_unit_price|Fri']); 
                    arData.push(sigmaView['Totallist_unit_price|Sat']);
            */
            //svnow get array
                var arData = [], arDataRight=[];
                for(var p=0; p < days.length; p++){

                 arData.push(sigmaView['Totallist_unit_price|' + days[p]]);
                 arDataRight.push(sigmaView['Totalquantity|' + days[p]]);
                }
                
                    
                     
             sigmaView.svWeeks= arData; 
             sigmaView.svWeeksRight= arDataRight;        
                    
                     
             sigmaView.svWeeks= arData; 


             sigmaInfo[svcatname] = sigmaView;
            // sigmaInfo[svcatname] = sigmaMeasure;

        }


        //sv now lopp to get aggreagte

        return sigmaInfo;



    };

    narrowDayTotalGuestDual(data, unitName, sigma, periodType, measure, channelView, channel, days) {
        //Step1 get buckets
        //var 
        let me = this
        var vView = {
            fromDate: "04/27/2016",
            toDate: "07/06/2017",
        };
        var sigmaInfo = channel.data.value;
        var sigmaView;

        //  var buckets = incomesvMonthSlots(1, vView.fromDate, vView.toDate);
        var buckets = ["Apr 2016", "May 2016", "Jun 2016", "Jul 2016"];
        

        //Step we have weeky excursion so we do not need week range

        for (var i = 0; i < unitName.length; i++) {
            var sigmaMeasure = 0;
            var svcatname =  me.fromBIName( me.ruleNames.SHORT.name, unitName[i]);
            var view = data[svcatname];
            if (view && _.isArray(view) && (view.length > 0)) {
                sigmaView = _.clone(view[0]);


            } else {

            }

            _.each(view, function(v, idx) {
                //got aft

                sigmaMeasure += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure] = sigmaMeasure;
           

            //sv dow for Monday
            var day = 'Mon';
             var svall = 0;

             _.each(view, function(v, idx) {
                //got aft

                svall += v['y'];

            });
            sigmaView['Total' + sigmaView.svMeasure+'|' +day] = svall;
           

            //svMon..
/*
                 var days = [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat',
                    'Sun'
                ];*/
                for(var m=0; m < days.length; m++){

                     me.pipeGuestDual( view, days[m], sigmaView,'delivery_guest_ids');


                }


                //svnow get array
             /*   var arData = [];
                 arData.push(sigmaView['Totallist_unit_price|Sun']);
                arData.push(sigmaView['Totallist_unit_price|Mon']);
                 arData.push(sigmaView['Totallist_unit_price|Tue']);
                  arData.push(sigmaView['Totallist_unit_price|Wed']);
                   arData.push(sigmaView['Totallist_unit_price|Thu']);
                    arData.push(sigmaView['Totallist_unit_price|Fri']); 
                    arData.push(sigmaView['Totallist_unit_price|Sat']);
            */
            //svnow get array
                var arData = [], arDataRight=[];
                for(var p=0; p < days.length; p++){

                 //arData.push(sigmaView['Totallist_unit_price|' + days[p]]);
                 arDataRight.push(sigmaView['Totaldelivery_guest_ids|' + days[p]]);
                }
                
                    
                     
            // sigmaView.svWeeks= arData; 
             sigmaView.svWeeksRight= arDataRight;        
                    
                     
           //  sigmaView.svWeeks= arData; 


             sigmaInfo[svcatname] = sigmaView;
            // sigmaInfo[svcatname] = sigmaMeasure;

        }


        //sv now lopp to get aggreagte

        return sigmaInfo;



    };

    narrowDay(data, unitName, sigma, periodType, measure, channelView, channel) {
        //Step1 get buckets
        //var 
        let me = this
        var vView = {
            fromDate: "04/27/2016",
            toDate: "07/06/2017",
        };
        var sigmaInfo = channel.data.value;
        var sigmaView;

        //  var buckets = incomesvMonthSlots(1, vView.fromDate, vView.toDate);
        var buckets = ["Apr 2016", "May 2016", "Jun 2016", "Jul 2016"];
        
        //Step we have weeky excursion so we do not need week range

        for (var i = 0; i < unitName.length; i++) {
            var sigmaMeasure = 0;
            var svcatname =  me.fromBIName( me.ruleNames.SHORT.name, unitName[i]);
            var view = data[svcatname];
            if (view && _.isArray(view) && (view.length > 0)) {
                sigmaView = _.clone(view[0]);


            } else {

            }

            _.each(view, function(v, idx) {
                //got aft

                sigmaMeasure += v['y'];

            })
            sigmaView['Total' + sigmaView.svMeasure] = sigmaMeasure
           

          
           

            //svMon..

                 var days = [
                    
                        '01',
                        '02',
                        '03',
                        '04',
                        '05',
                        '06',
                        '07',
                        '08',
                         '09',
                        '10',
                        '11',
                        '12',
                         '13',
                        '14',
                        '15',
                        '16',
                        '17',
                        '18',
                        '19',
                        '20',
                        '21',
                         '22',
                        '23',
                        '24'
                ];
                for(var m=0; m < days.length; m++){

   //  pipeHourDual( view, days[m], sigmaView, 'quantity');
                     me.pipeHourDual( view, days[m], sigmaView, 'quantity');


                }


                //svnow get array
                var arData = [], arDataRight=[];
                for(var p=0; p < days.length; p++){

                 arData.push(sigmaView['Totallist_unit_price|' + days[p]]);
                 arDataRight.push(sigmaView['Totalquantity|' + days[p]]);
                }
                
                    
                     
             sigmaView.svWeeks= arData; 
             sigmaView.svWeeksRight= arDataRight;


             sigmaInfo[svcatname] = sigmaView;
            // sigmaInfo[svcatname] = sigmaMeasure;

        }


        //sv now lopp to get aggreagte

        return sigmaInfo;



    };
     week = function(){
        var  calWeek= {

            0:{
                name:'Sun'
            },
            1:{
                name:'Mon'
            },
            2:{
                name:'Tue'
            },
            3:{
                name:'Wed'
            },
            4:{
                name:'Thu'
            },
            5:{
                name:'Fri'
            },
            6:{
                name:'Sat'
            }
        };
        return calWeek;


     };
     band = function(){
        var  calWeek= {

            0:{
                name:'0-5',
                min:0,
                max:6
            },
            1:{
                name:'6-12',
                 min:6,
                 max:13
            },
            2:{
                name:'13-20',
                min:13,
                 max:21
            },
            3:{
                 name:'21-27',
                min:21,
                 max:28
            },
            4:{
                name:'28-39',
                min:28,
                 max:40
            },
            5:{
                name:'40+',
                min:40,
                 max:300
           
            }
        };
        return calWeek;


     };
      getRegularHourName(utc) {

                //var utc = "2017-01-01T14:00:04.000Z";
                //var utc = "2017-07-20 11:06:19.184000+0000"
                var ar = utc.split('T');


               

                var mmDDYYYY = ar[0];
                var ts = ar[1]; 
               ts = ts.substr(0, 8);
                var time = {},
                    tokens;
                tokens = mmDDYYYY.split('-');
                time.month = Number(tokens[1]);
                time.month = time.month - 1;
                time.day = Number(tokens[2]);
                time.year = Number(tokens[0]);

                var tm = ts.split(':'), hh =tm[0], mm = tm[1], ss = tm[2];

               // 
           
           return '' + hh;
            

            };
            getRegularBandName(ageNumber) {
                let me = this
                //var utc = "2017-01-01T14:00:04.000Z";
                //var utc = "2017-07-20 11:06:19.184000+0000"
                var ageBand = me.band();
               var key =  _.findKey(ageBand, function(o){

                 // 
                  var test = false;
                  if ( (ageNumber >= o.min) && (ageNumber <o.max)) {
                    test = true;
                  }
                  return test;
                }, [ageNumber]);

              //3 is Wednes

          // 

           return ageBand[key].name;
         
            

            };

     getRegularDayName(utc) {
        let me = this
                //var utc = "2017-01-01T14:00:04.000Z";
                //var utc = "2017-07-20 11:06:19.184000+0000"
                var ar = utc.split('T');


               

                var mmDDYYYY = ar[0];
                var ts = ar[1]; 
               ts = ts.substr(0, 8);
                var time = {},
                    tokens;
                tokens = mmDDYYYY.split('-');
                time.month = Number(tokens[1]);
                time.month = time.month - 1;
                time.day = Number(tokens[2]);
                time.year = Number(tokens[0]);

                var tm = ts.split(':'), hh =tm[0], mm = tm[1], ss = tm[2];

               var  n = moment.tz(time, 'America/New_York');


              var regular = time.month + '/'+ time.day + '/' + time.year;

              //3 is Wednes
            var  diyIdx =   n.weekday();
            var  o = me.week();
           var dayName = o[diyIdx].name;
           return dayName;
            

            };

     pipeDay(view, day, sigmaView){

          //sv dow for Monday
            //var day = 'Mon';
            let me = this
             var svall = 0;
             var thisDay = day;


             _.each(view, function(v, idx) {
                 var orderDate = v['svtimestamp'];
                var dayName = me.getRegularDayName(orderDate);
                //got aft
                var test = false;
                if(thisDay == dayName){
                    test = true;
                }
                if(test === true){
                     svall += v['y'];

                }

               

            });
            sigmaView['Total' + sigmaView.svMeasure+'|' +day] = svall;
           

            //svMon..

     };

     pipeHour(view, hour, sigmaView){
         let me  =this
         var nHour, nEndHour, nStartHour;
          //sv dow for Monday       
            //var hour = 'Mon';
             var svall = 0;
             var startHour = hour;


             _.each(view, function(v, idx) {
                 var test = false;
                 var orderDate = v['svtimestamp'];
                var hourName = me.getRegularHourName(orderDate);
                nHour = parseInt(hourName);
                nStartHour = parseInt(startHour);
                 if(nStartHour ==  nHour){
                    test = true;
                 }


               

                if(test === true){
                     svall += v['y'];

                }

               

            });
            sigmaView['Total' + sigmaView.svMeasure+'|' +hour] = svall;

           

            //svMon..

     };


      pipeHourDual(view, hour, sigmaView, measureRight){
         var nHour, nEndHour, nStartHour;
         let me = this
          //sv dow for Monday       
            //var hour = 'Mon';
            measureRight = measureRight  || 'quantity';
             var svall = 0, svallRight=0;
             var startHour = hour;


             _.each(view, function(v, idx) {
                 var test = false;
                 var orderDate = v['svtimestamp'];
                var hourName = me.getRegularHourName(orderDate);
                nHour = parseInt(hourName);
                nStartHour = parseInt(startHour);
                 if(nStartHour ==  nHour){
                    test = true;
                 }


               

                if(test === true){
                     svall += v['y'];
                    svallRight += v['sv'+measureRight];

                }

               

            });
            sigmaView['Total' + sigmaView.svMeasure+'|' +hour] = svall;
            sigmaView['Total' + measureRight+'|' +hour] = svallRight;
            
           

            //svMon..

     };


      pipeDayDual(view, day, sigmaView, measureRight){

          //sv dow for Monday
            //var day = 'Mon';
            let me = this
             var svall = 0,svallRight=0;;
             var thisDay = day;
              measureRight = measureRight  || 'quantity';

             _.each(view, function(v, idx) {
                 var orderDate = v['svtimestamp'];
                var dayName = me.getRegularDayName(orderDate);
                //got aft
                var test = false;
                if(thisDay == dayName){
                    test = true;
                }
                if(test === true){
                     svall += v['y'];
                     svallRight += v['sv'+measureRight];

                }

               

            });
            sigmaView['Total' + sigmaView.svMeasure+'|' +day] = svall;
            sigmaView['Total' + measureRight+'|' +day] = svallRight;
           

            //svMon..

     };


      pipeGuestDual(view, day, sigmaView, measureRight){

          //sv dow for Monday
            //var day = 'Mon';
            let me = this
             var svall = 0,svallRight=0;;
             var thisDay = day;
              measureRight = measureRight  || 'delivery_guest_ids';

             _.each(view, function(v, idx) {
                 var orderDate = v['svtimestamp'];
                var dayName = me.getRegularDayName(orderDate);
                //got aft
                var test = false;
                if(thisDay == dayName){
                    test = true;
                }
                if(test === true){
                     //svall += v['y'];
                     //add for every guest ids
                     svallRight += 1;

                }

               

            });
           // sigmaView['Total' + sigmaView.svMeasure+'|' +day] = svall;
            sigmaView['Total' + measureRight+'|' +day] = svallRight;
           

            //svMon..

     };


     pipeAgeDual(view, band, sigmaView, measureRight, measureLeft){

          //sv dow for Monday
            //var band = '6-10';
            let me = this
             var svall = 0,svallRight=0;
             var thisBand = band;
              measureRight = measureRight  || 'female';
              measureLeft = measureLeft || 'male';

             _.each(view, function(v, idx) {
                 var orderDate = v['svage'];
                var bandName = me.getRegularBandName(orderDate);
                //got aft
                var test = false;
                if(thisBand == bandName){
                    test = true;
                }
                if(test === true){
                     svall += v['sv'+measureLeft];;
                     svallRight += v['sv'+measureRight];

                }

               

            });
            sigmaView['Total' + measureLeft+'|' +band] = svall;
            sigmaView['Total' + measureRight+'|' +band] = svallRight;
           

            //svMon..

     };

     transformMeasure(type, data, unitName, sigma, periodType, measure, channelView, channel) {
        //Step1 get buckets
        //var 
        let me = this
        let sigmaView = null
        var vView = {
            fromDate: "04/27/2016",
            toDate: "07/06/2017",
        };
        var sigmaInfo = channel.data.value;
        var measures;

        //  var buckets = incomesvMonthSlots(1, vView.fromDate, vView.toDate);
        var buckets = ["Apr 2016", "May 2016", "Jun 2016", "Jul 2016"];
        

        //Step we have weeky excursion so we do not need week range
        var svField =  me.aggegationName(type);

        for (var i = 0; i < unitName.length; i++) {
            var sigmaMeasure = 0;
           // var svcatname = transformCatNames('SHORT', unitName[i]);
            var svcatname =  me.fromBIName( me.ruleNames.SHORT.name, unitName[i]);
           
            var view = data[svcatname];

            if (view && _.isArray(view) && (view.length > 0)) {
                sigmaView = _.copy(view[0]);


            } else {

            }
            measures= [];

            _.each(view, function(v, idx) {
                //got aft

                //sigmaMeasure += v['y'];
                sigmaMeasure = v['y'];
                 measures.push(sigmaMeasure)

            });
            if(type ===2){
                sigmaView['Median' + sigmaView.svMeasure] = Math.median(measures);
             }else if(type ==3){
               
                sigmaView[svField + sigmaView.svMeasure] = Math.min(measures); 
              }else if(type ==4){
               
                sigmaView[svField + sigmaView.svMeasure] = Math.max(measures);   

              }else if(type ==5){
               
                sigmaView[svField + sigmaView.svMeasure] = measures.length;  
              }else if(type ==6){
               
                sigmaView[svField + sigmaView.svMeasure] = Math.round( Math.mean(measures),2);           

            }else{
                  sigmaView['Median' + sigmaView.svMeasure] = Math.median(measures);
            }
            
           
            sigmaInfo[svcatname] = sigmaView;

            // sigmaInfo[svcatname] = sigmaMeasure;

        }


        //sv now lopp to get aggreagte

        return sigmaInfo;



    };

    ageBands (){
        var ageBands = [
                   // '0-5',
                    '6-12',
                    '13-20',
                    '21-27',
                    '28-39',
                    '40+'
                   
                ];

                return ageBands;

    }


}